import { Table } from "reactstrap";
import InvoiceFiveHeader from "./InvoiceFiveHeader";
import InvoiceNumber from "./InvoiceNumber";
import InvoiceTable from "./InvoiceTable";
import InvoiceFiveSign from "./InvoiceFiveSign";
import { useRef } from "react";
import { InvoiceButtons } from "../Common/InvoiceButtons";

const InvoiceFiveContainer = () => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  return (
    <>
      <div ref={contentRef}>
        <Table style={{ width: "1075px", margin: "0 auto", background: "#fff" }} borderless>
          <tbody style={{ padding: "10px" }}>
            <tr>
              <td>
                <InvoiceFiveHeader />
              </td>
            </tr>
            <tr>
              <InvoiceNumber />
            </tr>
            <tr>
              <InvoiceTable />
            </tr>
            <InvoiceFiveSign />
          </tbody>
        </Table>
      </div>
      <InvoiceButtons contentRef={contentRef} />
    </>
  );
};

export default InvoiceFiveContainer;
